import type { CSSProperties } from 'react';
import { NumberField } from './NumberField';
import type { CylinderReading } from '../types/engine';

type CylinderEntryRowProps = {
  cylinders: CylinderReading[];
  field: 'egt' | 'cht';
  onChange: (id: number, value: number | undefined) => void;
  label?: string;
};

/** A compact horizontal row of per-cylinder number inputs for either EGT or
 *  CHT. Used inside the Wizard so pilots can type fresh values at every
 *  leaning step without navigating away. */
export function CylinderEntryRow({
  cylinders,
  field,
  onChange,
  label,
}: CylinderEntryRowProps) {
  return (
    <div>
      {label && (
        <div
          className="stat-label"
          style={{ marginBottom: 8, textTransform: 'uppercase' }}
        >
          {label}
        </div>
      )}
      <div
        className="cyl-entry-grid"
        style={{ '--cyl-count': cylinders.length } as CSSProperties}
      >
        {cylinders.map((c) => (
          <div key={c.id}>
            <div
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: 11,
                color: 'var(--ink-3)',
                fontWeight: 600,
                marginBottom: 4,
                textAlign: 'center',
              }}
            >
              #{c.id}
            </div>
            <NumberField
              value={c[field]}
              onChange={(v) => onChange(c.id, v)}
              align="center"
              min={field === 'egt' ? 600 : 100}
              max={field === 'egt' ? 1800 : 500}
              placeholder="—"
              ariaLabel={`Cylinder ${c.id} ${field.toUpperCase()}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
